module.exports = __webpack_public_path__ + "static/img/akum_600_35.e3b7c8b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/akumulator/akum_600_35.svg
// module id = MCsp
// module chunks = 1